import { Cause } from './Cause';
import { Peer } from './Peer';

export const Referrals = {
  Peer,
  Cause
};
